import { Directive, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';

@Directive({
    selector: '[appDragDrop]'
})
export class DragDropDirective {

    @Output() public onFileDropped = new EventEmitter<any>();

    @HostBinding('style.border') public border = '5px dashed #DDD';

    // Dragover listener
    @HostListener('dragover', ['$event']) public onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.border = '5px dashed blue';
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.border = '5px dashed #DDD';
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.border = '5px dashed #DDD';
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.onFileDropped.emit(files);
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/directives/drag-and-drop.derective.ts